module.exports = __webpack_public_path__ + "img/stores-empty.3149fcab.svg";